import moment from 'moment';

function convertTimestampToFormattedDate(timestamp) {
    const months = [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];

    const date = new Date(timestamp);
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    const formattedDate = `${day} ${month} ${year}`;
    return formattedDate;
}

function getProfileDOB(date) {
    return date === null ? "" : moment(date).format('YYYY-MM-DD');
}

function getDateWithTime(date) {
    return date === null ? "" : moment(date).format('DD MMM YYYY / HH:mm');
}

function getDate(date) {
    return date === null ? "" : moment(date).format('DD MMM YYYY');
}

function getTime(date) {
    return date === null ? "" : moment(date).format('HH:mm');
}

function convert_inches(inches) {
    let feetFromInches = Math.floor(inches / 12);
    let inchesRemainder = inches % 12;
    return feetFromInches + "'-" + inchesRemainder + "\"";
}

function safeGetDateWithTime(value) {
  if (!value) return "";
  if (typeof value === 'string') {
    const m = value.match(/^(\d{2})-(\d{2})-(\d{4})$/);
    if (m) {
      const [, dd, mm, yyyy] = m;
      const d = new Date(Number(yyyy), Number(mm) - 1, Number(dd));
      return getDateWithTime(d);
    }
  }
  return getDateWithTime(value);
};

function getSafeMediaUrl(url, fallback = '') {
    if (typeof url !== 'string') {
        return fallback;
    }

    const trimmedUrl = url.trim();
    if (!trimmedUrl) {
        return fallback;
    }

    if (trimmedUrl.startsWith('/')) {
        return trimmedUrl;
    }

    try {
        const parsedUrl = new URL(trimmedUrl, window.location.origin);
        const allowedProtocols = new Set(['http:', 'https:', 'blob:']);
        return allowedProtocols.has(parsedUrl.protocol) ? parsedUrl.href : fallback;
    } catch (error) {
        return fallback;
    }
}

export { convertTimestampToFormattedDate, getProfileDOB, getDateWithTime, getDate, getTime,convert_inches, safeGetDateWithTime, getSafeMediaUrl };
